var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M25.5717 51.6895L22.8245 36.3512L9.15332 34.1207C10.4624 33.3615 54.8468 12.3135 54.8468 12.3135L45.7175 45.7373L32.2106 38.6405L25.5717 51.6895Z","stroke":"currentColor","strokeWidth":"2","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M23.2549 35.9787L54.327 13.2349","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeDasharray":"3 3","key":1}),React.createElement("path",{"d":"M31.4561 37.8811L54.327 14.0806","stroke":"currentColor","strokeLinecap":"round","strokeDasharray":"3 3","key":2})]);
}

SVGIcon.defaultProps = {"viewBox":"0 0 64 65"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
